"use client";
import { useLocale } from "next-intl";
export default function EventError({ reset }: { reset: () => void }) {
  const locale = useLocale();
  return (
    <main className="min-h-[60vh] bg-[#06183e] px-5 py-24 text-center text-white">
      <h1 className="text-2xl font-semibold">
        {locale === "km"
          ? "មិនអាចផ្ទុកព័ត៌មានព្រឹត្តិការណ៍បានទេ។"
          : "Could not load the event."}
      </h1>
      <button
        type="button"
        onClick={reset}
        className="mt-6 rounded-full border border-[#f6cf63]/50 px-6 py-3 text-[#f6cf63]"
      >
        {locale === "km" ? "ព្យាយាមម្តងទៀត" : "Try again"}
      </button>
    </main>
  );
}
